import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerService from 'services/partnerService';
import { PartnerSearchResult } from 'views/ContactNoteForm/ContactNoteFormContainer';

export const useSearchMyTeamPartners = (usedInBr: boolean, searchQuery?: string) => {
  return useQuery<PartnerSearchResult[], AxiosError>({
    queryKey: ['getShortPartnerList', searchQuery || 'all'],
    queryFn: () => partnerService.searchMyTeamPartners(searchQuery),
    enabled: !usedInBr || !!searchQuery,
    onError: (error: AxiosError) => {
      // eslint-disable-next-line no-console
      console.error('[useFetchGetShortMyTeamPartners] Error fetching partners:', error);
    },
  });
};
